var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"page-footer"}},[_vm._t("default",[_c('div',{staticClass:"content py-3"},[_c('b-row',{staticClass:"font-size-sm"},[_c('b-col',{staticClass:"py-1 text-center text-sm-right"})],1)],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }